.packing-slip-sharing-header-content {
  align-items: center;
}

.info-icon-wrapper {
  display: inline-flex;
}

.info-icon {
  height: 16px;
  color: var(--default--icon--active--fill-color--1);
}
